import React from "react";
import { colors } from "../common/mixins.js";

interface TicketProps {
  color?: string;
}

export const TicketIcon = ({ color = colors.primary }: TicketProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_7886_21073)">
      <path
        d="M16.7999 12.0002C16.7999 11.006 17.6057 10.2002 18.5999 10.2002V7.2002H5.3999V10.2002C6.3941 10.2002 7.1999 11.006 7.1999 12.0002C7.1999 12.9944 6.3941 13.8002 5.3999 13.8002V16.8002H18.5999V13.8002C17.6057 13.8002 16.7999 12.9944 16.7999 12.0002Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.59985 10.8003H14.3999"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.59985 13.2002H14.3999"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7886_21073">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
